<template>
  <div>
    <div class="searchBlock" v-if="isDynamic">
      <el-divider content-position="left">二维表搜索配置</el-divider>
      <el-form-item label="可搜索">
        <el-switch v-model="data.isSearch"></el-switch>
      </el-form-item>
      <el-form-item v-if="data.isSearch" label="搜索方式">
        <el-radio-group v-model="data.searchWay" size="small">
          <el-radio-button label="equal">精确</el-radio-button>
          <el-radio-button label="like">模糊</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-form label-position="left" label-width="100px">
      <!-- 扩展 字段采集 开始 -->
      <el-form-item label="采集资源:" v-if="!isDynamic">
        <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：">
          <el-option v-for="item in resource" :key="item.resourceId" :label="item.tableComment"
            :value="item.resourceId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="采集字段:">
        <el-select clearable v-model="data.fieldName" placeholder="请选择采集字段">
          <el-option v-for="item in field" :key="item.columnName" :label="item.columnComment" :value="item.columnName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否回填：" v-if="!isDynamic">
        <el-switch v-model="data.writable"></el-switch>
      </el-form-item>
      <el-form-item label="联动URL：" label-width="100px" label-position="left">
        <el-input v-model="data.casUrl"></el-input>
      </el-form-item>
      <!-- 扩展 字段采集 结束 -->
      <el-form-item label="字体颜色：">
        <!--<el-color-picker v-model="data.color"></el-color-picker>-->
        <avue-color v-model="data.color"></avue-color>
      </el-form-item>
      <el-form-item label="加粗：">
        <el-switch v-model="data.fontWeight"></el-switch>
      </el-form-item>

      <el-form-item label="占位内容：">
        <el-input v-model="data.placeholder" placeholder="占位内容"></el-input>
      </el-form-item>
      <!-- 张杰 -- 2020/02/10 13:58 修改 valueDefault修改为value -->
      <!-- <el-form-item label="默认值：">
      <el-input v-model="data.valueDefault"
                placeholder="默认值"></el-input>
    </el-form-item> -->
      <el-form-item label="默认值：">
        <el-input v-model="data.value" placeholder="默认值"></el-input>
      </el-form-item>
      <el-form-item label="前缀：">
        <el-input v-model="data.prepend" placeholder="前缀"></el-input>
      </el-form-item>
      <el-form-item label="后缀：">
        <el-input v-model="data.append" placeholder="后缀"></el-input>
      </el-form-item>
      <el-form-item label="最大长度：">
        <el-input-number v-model="data.maxlength" controls-position="right" placeholder="最大长度"></el-input-number>
      </el-form-item>
      <el-form-item label="显示计数：" v-if="data.type != 'password'">
        <el-switch v-model="data.showWordLimit"></el-switch>
      </el-form-item>
      <el-form-item label="是否只读：">
        <el-switch v-model="data.disabled"></el-switch>
      </el-form-item>
      <el-form-item label="是否可见：">
        <el-switch v-model="data.display"></el-switch>
      </el-form-item>
      <el-form-item label="列隐藏：" v-if="isDynamic">
        <el-switch v-model="data.hide"></el-switch>
      </el-form-item>
      <el-form-item label="是否必填：">
        <el-switch v-model="data.required"></el-switch>
      </el-form-item>
      <el-form-item label="悬浮提示：" v-if="isDynamic">
        <el-switch v-model="data.showTip"></el-switch>
      </el-form-item>
      <el-form-item label="可展开：" v-if="isDynamic">
        <el-switch v-model="data.isExpand"></el-switch>
      </el-form-item>

      <el-form-item label="正则校验：">
        <el-input v-model.lazy="data.pattern" placeholder="正则表达式"></el-input>
      </el-form-item>
      <el-form-item label="OnClick事件：">
        <el-input type="textarea" v-model="data.mode" placeholder="事件的响应"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixinIsDynamic from '../../mixins/isDynamic'
export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigInput',
  props: ['data', 'widgetForm'],
  data() {
    return {
      resource: [],
      field: [],
      isMode: false,
      isSubmit: false,
      value: [],
      transferData: [],
      tableTitle: '',
      urlStr: '',
      toLabel: '',
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  computed: {
    selection: {
      get: function () {
        return this.$refs.mainTable.$refs.table.selection
      },
      set: function (newValue) {
        this.$refs.mainTable.$refs.table.selection = newValue
      }
    }
  },
  mounted() {

  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }
  },
  watch: {
    'data.resourceId': function (val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.required': function (val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.pattern': function (val) {
      if (val) this.validator.pattern = { pattern: val, message: `${this.data.label}格式不匹配` }
      else this.validator.pattern = null

      // delete this.data.pattern
      this.generateRule()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog-div {
  height: 430px;
  overflow: auto;
}
:deep(.el-dialog__header) {
  background-color: #406eff;
  height: 60px;
}
:deep(.el-dialog) {
  height: 600px;
}

:deep(.tableInfoCondition) {
  padding-left: 30px;
}
:deep(.el-dialog__body) {
  padding-bottom: 10px;
}
:deep(.el-dialog__wrapper) {
  margin-bottom: -90px;
  margin-left: 160px;
  overflow-y: hidden;
}
:deep(.el-dialog__title) {
  color: #fff;
  font-weight: bold;
  text-align: left;
}
:deep(.el-pager) {
  padding: 0 60px;
}
:deep(.el-transfer-panel) {
  width: 350px;
  padding-bottom: 20px;
}

:deep(.el-transfer-panel__body) {
  height: 380px;
}
:deep(.el-transfer-panel__list) {
  height: 360px;
}

:deep(.el-transfer-panel__footer) {
  height: 40px;
}
@import "./search.scss";
</style>
